/**
 * You can mock your wallet addresses by tweaking this variable.
 * @example
 * ```typescript
 * export const mockedAddresses: MockedAddress[] = [
 *   {
 *     walletAccount: 'exodus_0',
 *     assetName: 'ethereum',
 *     purpose: 44,
 *     address: 'your_eth_address',
 *   },
 *   {
 *     walletAccount: 'exodus_0',
 *     assetName: 'bitcoin',
 *     purpose: 84,
 *     address: 'your_btc_address',
 *   },
 * ];
 * ```
 */
export const mockedAddresses = undefined;
